// src/components/HeroSection.js
import React from "react";

export default function HeroSection({
    ctaLabel = "Start a Conversation",
    onPrimaryClick = () => {
        const contact = document.getElementById("contact");
        if (contact) {
            contact.scrollIntoView({ behavior: "smooth" });
        } else {
            window.location.href = "#start-a-conversation";
        }
    }
}) {
    return (
        <section
            aria-labelledby="hero-heading"
            className="px-6 md:px-12 lg:px-36 py-16"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[900px]">

                {/* SUPPORTING FRAME */}
                <p
                    className="mb-4 text-sm sm:text-base font-medium tracking-wide uppercase"
                    style={{ color: "var(--text-secondary)" }}
                >
                    <span className="text-[var(--color-primary)]">Fix</span> First.{" "}
                    <span className="text-[var(--color-primary)]">Scale</span> Next.
                </p>

                {/* PRIMARY HEADLINE */}
                <h1
                    id="hero-heading"
                    className="font-extrabold tracking-tight text-[2.2rem] sm:text-[3rem] md:text-[3.8rem] leading-tight"
                    style={{ color: "var(--text-primary)" }}
                >
                    Fix the{" "}
                    <span style={{ color: "var(--color-primary)" }}>
                        growth problem
                    </span>{" "}
                    you already know you have.
                </h1>

                {/* SUBHEAD */}
                <p
                    className="mt-6 max-w-[65ch] text-base sm:text-lg md:text-[1.1rem] leading-relaxed"
                    style={{ color: "var(--text-secondary)" }}
                >
                    I help founder-led D2C and subscription brands solve specific, high-leverage growth problems, using data you already have, before recommending new tools or hires.
                </p>


                {/* CTA */}
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <button
                        type="button"
                        onClick={onPrimaryClick}
                        aria-label={ctaLabel}
                        className="inline-flex items-center justify-center px-7 py-3 rounded-full text-sm md:text-base font-medium shadow-sm transform transition hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                        style={{
                            backgroundColor: "var(--text-primary)",
                            color: "var(--bg-surface)",
                        }}
                    >
                        {ctaLabel}
                    </button>
                </div>

            </div>
        </section>
    );
}
